module.exports = __webpack_public_path__ + "static/media/pagt4.9c623c2b.png";